// ============================================
// SYSTÈME DE FICHIERS - VERSION DÉMO
// ============================================

export type SecurityLevel = 'L01' | 'L02' | 'L03';

export interface FileNode {
    id: string;
    name: string;
    type: 'folder' | 'file';
    securityLevel: SecurityLevel;
    isGhost?: boolean;
    children?: FileNode[];
}

export interface FileContent {
    type: 'text' | 'image';
    title: string;
    content: string; // Text content or Image URL or i18n key
    encrypted?: boolean;
    isI18nKey?: boolean; // Indique si content est une clé i18n
}

// Codes d'authentification pour la démo
export const CREDENTIALS_DB: Record<string, { level: SecurityLevel, name: string }> = {
    'DEMO_USER': { level: 'L01', name: 'OPÉRATEUR STAGIAIRE' },
    'DEMO_SUPERVISOR': { level: 'L02', name: 'SUPERVISEUR' },
    'DEMO_ADMIN': { level: 'L03', name: 'ADMINISTRATEUR' },
};

// Arborescence des fichiers pour la démo
export const FILE_SYSTEM_TREE: FileNode[] = [
    {
        id: 'root_demo',
        name: 'CERTIFICATION_ALBION',
        type: 'folder',
        securityLevel: 'L01',
        children: [
            {
                id: 'folder_formation',
                name: 'FORMATION_L01',
                type: 'folder',
                securityLevel: 'L01',
                children: [
                    { id: 'f_manuel', name: 'MANUEL_OPERATEUR.txt', type: 'file', securityLevel: 'L01' },
                    { id: 'f_guide_interface', name: 'GUIDE_INTERFACE.txt', type: 'file', securityLevel: 'L01' },
                ]
            },
            {
                id: 'folder_avance',
                name: 'FORMATION_L02',
                type: 'folder',
                securityLevel: 'L01',
                children: [
                    { id: 'f_procedures', name: 'PROCEDURES_AVANCEES.txt', type: 'file', securityLevel: 'L01' },
                    { id: 'f_analyse_optique', name: 'GUIDE_ANALYSE_OPTIQUE.txt', type: 'file', securityLevel: 'L01' },
                    { id: 'f_image_a', name: 'IMAGE_A.jpg', type: 'file', securityLevel: 'L01' },
                    { id: 'f_image_b', name: 'IMAGE_B.jpg', type: 'file', securityLevel: 'L01' },
                ]
            },
            {
                id: 'folder_admin',
                name: 'ADMINISTRATION_L03',
                type: 'folder',
                securityLevel: 'L01',
                children: [
                    { id: 'f_certificat', name: 'CERTIFICAT_FORMATION.svg', type: 'file', securityLevel: 'L01' },
                ]
            }
        ]
    },
    {
        id: 'root_sys',
        name: 'SYSTÈME',
        type: 'folder',
        securityLevel: 'L01',
        children: [
            { id: 'sys_readme', name: 'README.txt', type: 'file', securityLevel: 'L01' },
        ]
    }
];

// Contenu des fichiers de démo
export const FILE_CONTENTS: Record<string, FileContent> = {
    'f_manuel': {
        type: 'text',
        title: 'MANUEL OPÉRATEUR - ALBION OS',
        content: 'demoFiles.f_manuel.content',
        isI18nKey: true
    },

    'f_guide_interface': {
        type: 'text',
        title: 'GUIDE INTERFACE UTILISATEUR',
        content: 'demoFiles.f_guide_interface.content',
        isI18nKey: true
    },

    'f_procedures': {
        type: 'text',
        title: 'PROCÉDURES AVANCÉES',
        content: 'demoFiles.f_procedures.content',
        isI18nKey: true
    },

    'f_analyse_optique': {
        type: 'text',
        title: 'GUIDE ANALYSE OPTIQUE',
        content: 'demoFiles.f_analyse_optique.content',
        isI18nKey: true
    },

    'f_certificat': {
        type: 'image',
        title: 'CERTIFICAT DE FORMATION',
        content: './data/png/certificat_formation.svg',
        encrypted: false
    },

    'sys_readme': {
        type: 'text',
        title: 'README - ALBION OS DÉMO',
        content: 'demoFiles.sys_readme.content',
        isI18nKey: true
    },

    'f_image_a': {
        type: 'image',
        title: 'IMAGE A - ANALYSE OPTIQUE',
        content: './alice.a.jpg',
        encrypted: false
    },

    'f_image_b': {
        type: 'image',
        title: 'IMAGE B - ANALYSE OPTIQUE',
        content: './alice.b.jpg',
        encrypted: false
    }
};
